<div class="container">
  <i aria-hidden="true" [ngClass]="typeIcon"></i>
  <div class="personal-info-cont" (click)="selectTraveler.emit(traveler)">
    <span class="name">{{traveler.first_name}} {{traveler.last_name}}</span>
    <span class="dni" *ngIf="!!traveler.document_number"><span class="type-dni">{{documentAbreviation$ | async}}: </span>{{  traveler.document_number }}</span>
  </div>
  <div class="options" (click)="toggleOptions()">
    <span class="separator">●</span>
    <span class="separator">●</span>
    <span class="separator">●</span>
  </div>
</div>

<div *ngIf="showOptions" (click)="toggleOptions()" class="overlay-container"></div>

<div *ngIf="showOptions" class="transparent-container" (click)="toggleOptions()">
  <section class="opt-cont" [class.is-last]="isLast" [class.only-one]="onlyOne">
    <div class="options-container">
      <span (click)="edit.emit(traveler)" class="edit">
        <i aria-hidden="true" class="icon-edit"></i>
        <span>{{'BUTTONS.EDIT' | transloco}}</span>
      </span>
      <span (click)="removeItem()">
        <i aria-hidden="true" class="icon-cancel"></i>
        <span>{{ 'BOOKING_MODULE.BILLING.DELETE' | transloco }}</span>
      </span>
    </div>
  </section>
</div>